<template>
  <div class="docitemcol d-md-flex d-block col-md-3 col-6 gap-2 align-items-baseline">
    <label class="form-label">{{ $t(label) }}</label>
    <span>{{ title }}</span>
  </div>
</template>

<script setup>
defineProps({
  title: {
    type: String
  },
  label: {
    type: String
  }
})
</script>

<style scoped lang="scss">
  .docitemcol {
    margin-bottom: 12px;
    font-size: 15px;
    .form-label {
      margin-bottom: 0;
      min-width: 80px;
    }
  }
  @media screen and (max-width: 768px) {
    .docitemcol {
      font-size: 12px;
      .form-label {
        display: block;
      }
    }
  }
</style>
